<script>
import { filter } from 'lodash-es';

export default {
  name: 'ItineraryDayProgramMealPlanModal',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    itineraryId: {
      type: Number,
      required: true,
    },
    mealPlanTypes: {
      type: Array,
      default: () => [],
    },
    mealPlanOptions: {
      type: Array,
      default: () => [],
    },
    dayProgram: {
      type: Object,
      default: () => {},
    },
    mealPlanMappings: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      toggled: true,
      mealPlanData: [],
      formData: [],
    };
  },
  watch: {
    toggled(value) {
      if (!value) {
        this.$emit('cancel');
      }
    },
    mealPlanMappings() {
      this.formatFormData();
    },
  },
  methods: {
    formatFormData() {
      this.mealPlanMappings.forEach((item) => {
        const mealPlan = filter(this.mealPlanData, data => data.mealType === item.mealType);
        mealPlan[0].mealOption = item.mealOption;
        mealPlan[0].drinksIncluded = item.drinksIncluded;
      });
    },
    update() {
      const filterMappings = this.mealPlanData.filter(
        object => object.mealOption || object.drinksIncluded,
      );

      this.$emit('update', {
        itineraryId: this.itineraryId,
        dayProgramId: this.dayProgram.id,
        mappings: filterMappings,
      });
    },
  },
  created() {
    this.mealPlanTypes.forEach((type) => {
      this.mealPlanData.push(
        Object.assign({ ...{
          mealType: type,
          mealOption: null,
          drinksIncluded: false,
        } }),
      );
    });

    this.formatFormData();
  },
};
</script>

<template>
  <v-dialog
    v-model="toggled"
    max-width="600px"
  >
    <v-card>
      <v-flex font-weight-bold pa-3 title>
        <v-icon>fastfood</v-icon>
        <span>{{ this.$t('itinerary.mealPlanModal.title') }}</span>
      </v-flex>
      <v-layout row wrap>
        <v-flex xs12>
          <v-progress-linear
            v-if="loading"
            class="my-0"
            :active="loading"
            :indeterminate="true"
            :height="4"
          />
        </v-flex>
        <v-flex
          class="px-3"
          xs12
        >
          <v-layout row>
            <v-flex xs4 class="pr-4 pt-3">
              <h3>{{ $t('itinerary.mealPlanModal.headers.type') }}</h3>
            </v-flex>
            <v-flex xs4>
              <h3>{{ $t('itinerary.mealPlanModal.headers.option') }}</h3>
            </v-flex>
            <v-flex xs4>
              <h3 class="ml-5">{{ $t('itinerary.mealPlanModal.headers.drinksIncluded') }}</h3>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-divider/>
        <v-flex
          v-for="mealPlan in mealPlanData"
          :key="mealPlan.mealType"
          class="px-3"
          xs12
        >
          <v-layout row>
            <v-flex xs4 class="pr-4 pt-3">
              <span>{{ $t(`itinerary.mealPlanModal.mealPlanTypes.${mealPlan.mealType}`) }}</span>
            </v-flex>
            <v-flex xs4>
              <v-select
                v-model="mealPlan.mealOption"
                :items="mealPlanOptions"
                :disabled="loading"
                solo
                clearable
                label="Select option"
              >
                <template slot="selection" slot-scope="data">
                  {{ $t(`itinerary.mealPlanModal.mealPlanOptions.${data.item}`) }}
                </template>
                <template slot="item" slot-scope="data">
                  {{ $t(`itinerary.mealPlanModal.mealPlanOptions.${data.item}`) }}
                </template>
              </v-select>
            </v-flex>
            <v-flex xs4>
              <v-checkbox
                v-model="mealPlan.drinksIncluded"
                :disabled="loading"
                class="mt-2 ml-5"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout justify-end>
        <v-btn
          color="red darken-1"
          flat
          @click="toggled = false"
        >
          {{ $t('inputs.actions.cancel') }}
        </v-btn>
        <v-btn
          :disabled="loading"
          :loading="loading"
          color="blue darken-1"
          flat
          @click="update"
        >
          {{ $t('inputs.actions.save') }}
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryDayProgramMealPlanModal.vue